import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import EditWorkforceLayer from "./EditWorkforceLayer";


const EditAddWorkForcePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Edit Workforce" />

        {/* AddUserLayer */}
        <EditWorkforceLayer />


      </MasterLayout>
    </>
  );
};

export default EditAddWorkForcePage;
